<template>
  <div>
    <v-dialog
      ref="cartDialog"
      v-model="localDialog"
      transition="dialog-bottom-transition"
      :max-width="activeComercial ? '800px' : '1400px'"
      class="dialog-z-index-general"
      content-class="productModal cart-modal youReprocesosProductModal margin-top-banner"
    >
      <template #activator="{ on }">
        <v-badge
          class="w-100"
          :content="clientCartAvalible ? countClientCart : countComercialCart"
          overlap
          bordered
          :value="
            clientCartAvalible ? countClientCart != 0 : countComercialCart != 0
          "
        >
          <CotizadorBtn dark :on="on" content-class="w-100">
            <v-icon class="mr-2">$fi-file-text</v-icon>
            <span>{{ $t("general.ResumenPedido") }}</span>
          </CotizadorBtn>
        </v-badge>
      </template>
      <v-card :loading="loading != 0 ? 'primary' : false">
        <!--  Titulo del modal -->
        <v-card-title class="pa-0">
          <v-toolbar height="fit-content" dark color="black">
            <v-toolbar-title
              class="productos-titulo d-flex justify-space-between"
            >
              <v-container fluid>
                <v-row>
                  <v-col cols="12" md="8" class="d-flex align-center py-0">
                    <v-row>
                      <v-col cols="12" md="6" class="d-flex align-center py-0">
                        <span v-if="modelCode" class="modelo-name">
                          {{ $t(`MODELS.${modelCode}.NAME`) }}
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                        class="d-flex justify-md-center align-center py-0"
                      >
                        <span>
                          {{ $t("general.Pedido") }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12"  md="4" class="d-flex flex-row-reverse pr-0 py-0">
                    <div class="right-border" @click="cerrar">
                      <v-btn icon dark>
                        <v-icon xl>mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-toolbar-title>
          </v-toolbar>
        </v-card-title>

        <div  v-if="activeComercial">
          <div class="d-flex flex-column align-center">
            <div class="mt-3 d-flex flex-column align-center">
              <h5>
                {{ loggedClient.clientId }} -
                {{ loggedClient.clientName }}
              </h5>
              <h5>{{ userOfClient.label }}</h5>
            </div>
          </div>
        </div>

        <v-card-text class="mw-100 px-5 py-0 mt-3">
          <v-row>
            <v-col
              v-if="!activeComercial"
              cols="12"
              md="6"
              class="right-border pr-md-5 mb-4"
            >
              <v-row class="presupuestoBody mx-3">
                <v-col>
                  <h2 class="title1">
                    {{ $t("presupuesto.incrementoTitle") }}
                  </h2>
                  <v-divider class="mt-1" />
                  <h3 class="subtitle1 mt-2">
                    {{ $t("presupuesto.incrementoSubtitle") }}
                  </h3>

                  <v-row class="mt-3">
                    <v-col class="pt-0">
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.porcproductos") }}</span>
                        <v-text-field
                          v-model="misPrecios.porcentajeProductos"
                          class="mt-1"
                          type="number"
                          min="0"
                          step="1"
                          dense
                          filled
                          hide-details
                        />
                      </div>
                    </v-col>
                    <v-col class="pt-0">
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.porcreprocesos") }}</span>
                        <v-text-field
                          v-model="misPrecios.porcentajeReprocesos"
                          class="mt-1"
                          type="number"
                          min="0"
                          step="1"
                          dense
                          hide-details
                          filled
                        />
                      </div>
                    </v-col>
                    <v-col class="pt-0">
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.costesextras") }}</span>
                        <v-text-field
                          v-model="misPrecios.costeExtra"
                          class="mt-1"
                          type="number"
                          min="0"
                          step="1"
                          dense
                          hide-details
                          filled
                        />
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-3">
                    <v-col>
                      <span class="inLineInput">
                        {{ $t("presupuesto.Observaciones") }}
                      </span>
                      <v-textarea
                        v-model="misPrecios.Observaciones"
                        dense
                        auto-grow
                        filled
                        no-resize
                        rows="2"
                        counter="250"
                      />
                    </v-col>
                  </v-row>

                  <h2 class="title1">{{ $t("presupuesto.MisDatos") }}</h2>
                  <v-divider class="mt-1" />
                  <v-row class="mt-2">
                    <v-col cols="9" class="encabezado">
                      <b>{{ $t("presupuesto.encabezadoTitle") }}</b>
                      <span>
                        {{ $t("presupuesto.encabezadoHelper") }}
                      </span>
                      <v-btn
                        :loading="isSelecting"
                        class="mt-3"
                        large
                        @click="handleFileImport"
                      >
                        <v-icon color="primary" class="mr-3">
                          mdi-plus-circle
                        </v-icon>
                        {{ $t("presupuesto.encabezadoUpload") }}
                      </v-btn>
                      <input
                        ref="uploader"
                        class="d-none"
                        type="file"
                        accept="image/*"
                        @change="selectFile"
                      />
                    </v-col>
                    <v-col cols="3">
                      <v-row>
                        <v-col v-if="idImg">
                          <v-img
                            :id="idImg"
                            class="centerImg"
                            :src="misPrecios.CustomLogoPath"
                            width="85"
                            height="120"
                          />
                          <div class="centerContainer">
                            <v-btn @click="resetImg">
                              {{
                                $t("configuration.ReprocesosGenerales.Eliminar")
                              }}
                              <v-icon>$fi-trash-2</v-icon>
                            </v-btn>
                          </div>
                        </v-col>
                        <v-col v-else>
                          <v-img
                            src="@/assets/Page-encabezado.svg"
                            width="85"
                            height="120"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.Empresa") }}</span>
                        <v-text-field
                          v-model="misPrecios.Empresa"
                          hide-details
                          filled
                          clearable
                          dense
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.Correo") }}</span>
                        <v-text-field
                          v-model="misPrecios.correoContacto"
                          hide-details
                          filled
                          clearable
                          dense
                          type="email"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="5">
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.Teléfono") }}</span>
                        <v-text-field
                          v-model="misPrecios.telefono"
                          hide-details
                          filled
                          clearable
                          dense
                          type="tel"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.DireccionCalle") }}</span>
                        <v-text-field
                          v-model="misPrecios.calle"
                          hide-details
                          filled
                          clearable
                          dense
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="5">
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.CP") }}</span>
                        <v-text-field
                          v-model="misPrecios.cp"
                          hide-details
                          filled
                          clearable
                          dense
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.Poblacion") }}</span>
                        <v-text-field
                          v-model="misPrecios.poblacion"
                          hide-details
                          filled
                          clearable
                          dense
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col>
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.Ciudad") }}</span>
                        <v-text-field
                          v-model="misPrecios.ciudad"
                          hide-details
                          filled
                          clearable
                          dense
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col>
                      <div class="inLineInput">
                        <span>{{ $t("presupuesto.Pais") }}</span>
                        <v-text-field
                          v-model="misPrecios.pais"
                          hide-details
                          filled
                          clearable
                          dense
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              :md="activeComercial ? 12 : 6"
              :class="!activeComercial ? 'pl-md-5' : ''"
            >
              <v-container>
                <v-row class="cart-item-list">
                  <v-col class="pt-0">
                    <v-container class="overflow-y-auto">
                      <!-- <v-row>
                        <v-col>
                          <span class="title-presupuestos-realizados">
                            {{ $t("cart.titleCartPresupuestosRealizados") }}
                          </span>
                        </v-col>
                      </v-row> -->
                      <v-row class="scroll-container">
                        <v-col>
                          <template v-if="totalActualCart > 0">
                            <cart-element
                              is-checkable
                              :cart="actualCart"
                              :loading="loading != 0"
                              :modification-config="misPrecios"
                              :disable-check="loading != 0 || loadingCarrito"
                              @updateChecked="updateSelectedId"
                            ></cart-element>
                          </template>
                          <template v-else>
                            <div
                              class="d-flex justify-center align-center loading-cart"
                            >
                              <v-icon class="icon-cart mr-3" large>
                                mdi-cart-outline
                              </v-icon>
                              <div>
                                <span class="subtitle1">
                                  {{ $t("cart.EmptyCart") }}
                                </span>
                                <br />
                                <span class="subtitle1">
                                  {{ $t("cart.SubheaderEmptyCart") }}
                                </span>
                              </div>
                            </div>
                          </template>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="d-flex clean-cart-text">
                          <v-spacer />
                          <!-- <a
                            :disabled="loading != 0 || totalActualCart == 0"
                            href="javascript:;"
                            @click="deleteCart"
                          >
                            {{ $t("cart.CleanCart") }}
                          </a> -->
                          <a
                            :disabled="loading != 0 || totalActualCart == 0"
                            href="javascript:;"
                            @click="deleteCart"
                          >
                            {{ $t("cart.CleanCart") }}
                          </a>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-0">
                          <!-- <v-card color="primary">
                            <v-card-actions>
                              <v-spacer />
                              <span class="totalHeader">
                                {{ $t("presupuesto.fichaReprocesos.Total") }}:
                                {{ totalActualCart }}
                                {{ currencySymbol }}
                              </span>
                            </v-card-actions>
                          </v-card> -->
                          <span class="total-span">
                            {{ $t("presupuesto.fichaReprocesos.Total") }}
                          </span>
                          <v-divider />
                          <span class="price-total-span">
                            {{ totalSelectedReprocesos | filtrarPreciosDosDecimales }}
                            {{ currencySymbol }}
                          </span>
                          <span class="litle-head-title">{{ $t("cart.plusTaxes") }}</span>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
                <v-row class="extra-info-row mt-0">
                  <v-col class="pt-0">
                    <v-container class="">
                      <v-row>
                        <v-col>
                          <span class="label-input">
                            {{ $t("cart.DireccionesEnvio") }}
                          </span>
                          <v-radio-group
                            v-model="direcciones"
                            class="radio-group-direction mt-0"
                            hide-details
                            filled
                            row
                          >
                            <v-radio
                              off-icon="$fi-square"
                              on-icon="$fi-check-square"
                              :value="false"
                            >
                              <template #label>
                                {{ $t("cart.DireccionesGuardadas") }}
                              </template>
                            </v-radio>
                            <v-radio
                              off-icon="$fi-square"
                              on-icon="$fi-check-square"
                              :value="true"
                            >
                              <template #label>
                                {{ $t("cart.DireccionNuevaCliente") }}
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col class="pb-0">
                          <template v-if="!direcciones">
                            <v-select
                              v-model="selectedDireccion"
                              :items="shippingAddress"
                              :label="$t('presupuesto.DireccionCalle')"
                              filled
                              dense
                              hide-details
                              item-text="address"
                              item-value="codToken"
                              :loading="loading != 0"
                              class="items-address-selector"
                            >
                              <template #item="{ item }">
                                <div
                                  class="mt-2 pa-1 px-0 individual-address-item"
                                >
                                  <strong>
                                    {{ item.address }}
                                  </strong>
                                  <br />
                                  <span>
                                    {{ item.countrycode }}
                                  </span>
                                  <br />
                                  <span>
                                    {{
                                      `${item.street} ${item.cp} ${item.city} ${item.state} ${item.country}`
                                    }}
                                  </span>
                                  <br />
                                </div>
                              </template>
                            </v-select>
                          </template>
                          <template v-else>
                            <address-creator
                              v-model="customAddress"
                              :avalible.sync="avalibleCustomAddress"
                              :loading="loading != 0"
                              container-class="pa-0"
                            />
                          </template>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="pb-0">
                          <span class="label-input">
                            {{ $t("cart.presupuesto.ObservacionesAgencia") }}
                          </span>
                          <v-textarea
                            v-model="observacionesAgencia"
                            class="mt-1"
                            filled
                            dense
                            auto-grow
                            no-resize
                            hide-details
                            rows="1"
                            counter="250"
                            :rules="[
                              observacionesAgenciaValid ||
                                $t('cart.MaxInputObservaciones', {
                                  numCaracter: 250
                                })
                            ]"
                          />
                        </v-col>
                      </v-row>

                      <v-row class="mt-0">
                        <v-col class="pb-0">
                          <span class="label-input">
                            {{ $t("cart.Referencia") }}
                          </span>
                          <v-textarea
                            v-model="referencia"
                            class="mt-1"
                            filled
                            dense
                            auto-grow
                            no-resize
                            hide-details
                            rows="1"
                            counter="100"
                            :rules="[
                              referenceValid ||
                                $t('cart.MaxInputObservaciones', {
                                  numCaracter: 100
                                })
                            ]"
                          />
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="pb-0">
                          <span class="label-input">
                            {{ $t("presupuesto.Observaciones") }}
                          </span>
                          <v-textarea
                            v-model="observaciones"
                            class="mt-1"
                            filled
                            dense
                            auto-grow
                            no-resize
                            rows="2"
                            counter="250"
                            :rules="[
                              observacionesValid ||
                                $t('cart.MaxInputObservaciones', {
                                  numCaracter: 250
                                })
                            ]"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="d-flex align-center">
          <v-row>
            <!-- Selector de tipo de operación (Solo comercial) -->
            <v-col v-if="activeComercial" cols="12" class="d-flex justify-end py-0">
              <div class="d-flex flex-column">
                <span class="label-input">
                {{ $t("cart.typeOrderReprocesos") }}
              </span>
              <v-radio-group
                v-model="operationType"
                class="radio-group-operation mt-0"
                hide-details
                row
              >
                <v-radio
                  off-icon="$fi-square"
                  on-icon="$fi-check-square"
                  value="presupuesto"
                >
                  <template #label>
                    {{ $t("general.Presupuesto") }}
                  </template>
                </v-radio>
                <v-radio
                  off-icon="$fi-square"
                  on-icon="$fi-check-square"
                  value="pedido"
                >
                  <template #label>
                    {{ $t("general.Pedido") }}
                  </template>
                </v-radio>
              </v-radio-group>
              </div>
            </v-col>

            <v-col v-if="!activeComercial" class="pb-0" cols="0" md="5" />
            <v-col cols="12" :md="activeComercial ? 12 : 7" class="pb-0 d-flex justify-center">
              <v-col>
                <cotizador-btn
                  class="mr-2 w-100"
                  content-class="w-100"
                  :loading="loading != 0"
                  :disabled="
                    loading != 0 || loadingCarrito || totalSelectedReprocesos == 0 || selectedReprocesosId.length == 0
                  "
                  :on="{
                    click: dowloadAllBocetosInCartModificaciones
                  }"
                >
                  <v-icon size="20" class="mr-3">$fi-download</v-icon>
                  {{ $t("general.general.bocetos")}}
                </cotizador-btn>
              </v-col>
              <v-col>
                <cotizador-btn
                  class="mr-2 w-100"
                  content-class="w-100"
                  :loading="loading != 0"
                  :disabled="
                    loading != 0 || loadingCarrito || totalSelectedReprocesos == 0 || selectedReprocesosId.length == 0
                  "
                  :on="{
                    click: dowloadAllPresupuestosInCartWithPrices
                  }"
                >
                  <v-icon size="20" class="mr-3">$fi-download</v-icon>
                  <div class="d-flex flex-column">
                    <span>{{ $t("presupuesto.guardar") }}*</span>
                  </div>
                </cotizador-btn>
                <div class="subtitle-button">* {{ $t("cart.taxNotIncluded") }}</div>
              </v-col>
              <v-col>
                <v-btn
                  class="w-100"
                  content-class="w-100"
                  :loading="loading != 0 || loadingCarrito"
                  :disabled="!avalibleConfirm || selectedReprocesosId.length == 0"
                  color="primary"
                  @click="openConfirmDialog()"
                >
                  {{ operationType == 'pedido' ? $t("general.GenerarPedido") : $t("cart.generatePresupuesto") }}
                </v-btn>
              </v-col>

              <!-- <pdf class="mr-3" cotizador-btn :mis-precios="misPrecios"/> -->
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <v-dialog
        ref="confirmDialogCart"
        v-model="confirmDialog"
        class="dialog-z-index-general"
        max-width="440px"
      >
        <v-card
          elevation="4"
          outlined
          class="dialog-restart"
          color="bannerBackground"
        >
          <v-card-title class="d-flex flex-column justify-center align-center">
            {{ $t("cart.confirmDialogTitle") }}
          </v-card-title>
          
          <v-card-text class="d-flex flex-column justify-center mt-2">
            <span class="confirm-dialog-text">
              {{ $t("cart.confirmDialogText") }}
            </span>

            <div class="aca-calculation mt-4">
              <template v-if="acaLoading">
                <div class="d-flex flex-column align-center">
                  <v-progress-circular
                    indeterminate
                    color="colorTextBanner"
                    class="mb-2"
                  ></v-progress-circular>
                  <span>{{ $t("cart.loadingAca") }}</span>
                </div>
              </template>
              <template v-else-if="acaError">
                <v-alert color="error">{{ $t("cart.acaError") }}</v-alert>
              </template>
              <template v-else-if="avalibleAca">
              <div class="orders-scroll-container pr-2">
                
                <div 
                  v-for="(order, i) in jsonAca.ReprocesosOrders" 
                  :key="`order-${i}`"
                  class="mb-3"
                >
                    <v-card class="order-summary-card elevation-2">
                      <div class="order-card-header grey lighten-4 pa-2">
                        <span class="font-weight-bold ml-2">
                           {{ $t("cart.desglosePedido") }} {{ i + 1 }} <template v-if="order.Suborders.length > 1">({{ order.Suborders.length }})</template>
                        </span>
                      </div>
                      <v-divider></v-divider>
                      
                      <!-- Detalle de Reprocesos Individuales -->
                      <div class="pa-2 grey lighten-5">
                         <div 
                            v-for="(sub, j) in order.Suborders" 
                            :key="`sub-${j}`"
                            class="d-flex justify-space-between suborder-item"
                         >
                            <div class="d-flex align-center">
                                <v-icon small class="mr-2">mdi-package-variant-closed</v-icon>
                                <div class="suborder-info">
                                    <span class="suborder-name">
                                        {{ $t("MODELS." + (getReprocesoFromCart(sub.IdReproceso)?.productos?.[0]?.modelo || '') + ".NAME") }}
                                    </span>
                                    <span class="suborder-ref">
                                        Ref: {{ getReprocesoFromCart(sub.IdReproceso)?.productos?.[0]?.modelo }} - {{ sub.IdReproceso }}
                                    </span>
                                </div>
                            </div>
                            <span class="font-weight-medium caption align-self-center">
                              {{ getReprocesoTotalFromCart(sub.IdReproceso) | filtrarPreciosDosDecimales }} {{ currencySymbol }}
                            </span>
                         </div>
                      </div>

                      <v-divider class="mx-3"></v-divider>

                      <!-- Totales Agrupados -->
                      <div class="order-card-body pa-3">
                        
                        <div class="cost-row">
                            <span class="cost-label font-weight-bold">
                              {{ $t("cart.subtotal") }}
                            </span>
                            <span class="cost-value font-weight-bold">
                              {{ getOrderBaseAmount(order) | filtrarPreciosDosDecimales }} {{ currencySymbol }}
                            </span>
                        </div>

                        <!-- Gastos de Envío -->
                        <div class="cost-row">
                          <span class="cost-label">{{ $t("cart.Envio") }}</span>
                          <span class="cost-value">
                            {{ getOrderShipping(order) | filtrarPreciosDosDecimales }} {{ currencySymbol }}
                          </span>
                        </div>

                        <!-- Impuestos Agrupados -->
                        <div 
                          v-for="(tax, k) in getOrderTaxes(order)" 
                          :key="`tax-${k}`" 
                          class="cost-row"
                        >
                          <span class="cost-label">
                            {{ tax.DescrIva || 'IVA' }}
                          </span>
                          <span class="cost-value">
                            {{ tax.Iva | filtrarPreciosDosDecimales }} {{ currencySymbol }}
                          </span>
                        </div>
                        
                        <!-- Si no hay impuestos (opcional) -->
                        <div 
                          v-if="getOrderTaxes(order).length === 0" 
                          class="cost-row"
                        >
                          <span class="cost-label">{{ $t("cart.taxDim") }}</span>
                          <span class="cost-value">
                            {{ 0 | filtrarPreciosDosDecimales }} {{ currencySymbol }}
                          </span>
                        </div>

                        <!-- Extras Agrupados -->
                        <template v-for="(val, name) in getOrderExtras(order)">
                            <div v-if="name !== 'Bultos' && val > 0" :key="name" class="cost-row">
                                <span class="cost-label">
                                    {{ name === 'GastosMani' ? $t("cart.manipulacion") : 
                                       name === 'Canon' ? $t("cart.canonDigital") :
                                       name === 'Despaduana' ? $t("cart.despachoAduanas") :
                                       name === 'ArancelUk' ? $t("cart.arancelUk") : name
                                    }}
                                </span>
                                <span class="cost-value">
                                    {{ val | filtrarPreciosDosDecimales }} {{ currencySymbol }}
                                </span>
                            </div>
                        </template>

                        <div v-if="getOrderExtras(order).Bultos > 0" class="cost-row mt-2">
                          <span class="cost-label"></span>
                          <span class="cost-value caption grey--text">
                             {{ getOrderExtras(order).Bultos }} {{ $t("cart.bultos") }}
                          </span>
                        </div>

                        <v-divider class="my-2 divider-light"></v-divider>
                        
                        <div class="total-row">
                          <span class="total-label">{{ $t("general.Total") }}</span>
                          <span class="total-value">
                            {{ calculateOrderTotal(order) | filtrarPreciosDosDecimales }} {{ currencySymbol }}
                          </span>
                        </div>

                      </div>
                    </v-card>
                </div>
              </div>

              <div class="grand-total-section mt-3">
                <div class="d-flex justify-space-between caption  text--lighten-1 mb-2 px-2">
                  <span>{{ $t("cart.subtotal") }}: {{ totalSelectedReprocesos | filtrarPreciosDosDecimales }}{{ currencySymbol }}</span>
                  <span>{{ $t("cart.Envio") }}: {{ totalAcaEnvio | filtrarPreciosDosDecimales }}{{ currencySymbol }}</span>
                  <span>{{ $t("cart.taxDim") }}: {{ totalImpuestos | filtrarPreciosDosDecimales }}{{ currencySymbol }}</span>
                </div>

                <v-card color="white" class="black--text elevation-4 rounded-lg">
                  <div class="d-flex justify-space-between align-center px-4 py-3">
                    <div class="d-flex flex-column">
                      <span class="text-uppercase font-weight-bold caption opacity-80">
                        {{ $t("general.Total") }}
                      </span>
                      <span v-if="totalOtrosCalculos > 0" class="caption opacity-80">
                        ({{ $t("cart.extraTotal") }})
                      </span>
                    </div>
                    <span class="text-h5 font-weight-bold">
                      {{ granTotal | filtrarPreciosDosDecimales }} {{ currencySymbol }}
                    </span>
                  </div>
                </v-card>
              </div>
            </template>
            </div>
          </v-card-text>

          <v-card-actions class="d-flex align-center pr-0">
            <v-spacer v-if="!activeComercial"></v-spacer>
            <v-btn
              class="white--text"
              :disabled="loading != 0"
              dark
              @click="confirmDialog = false"
            >
              {{ $t("general.Cancelar") }}
            </v-btn>
            <v-btn
              :loading="loading != 0 || loadingCarrito"
              :disabled="!avalibleConfirm || loading != 0 || selectedReprocesosId.length == 0 || !avalibleAca"
              @click="confirmAll"
            >
              {{ $t("cart.enviar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import cartElement from "../basic/cartElement.vue";
import AddressCreator from "@/components/basic/AddressCreator.vue";
import CotizadorBtn from "@/components/basic/CotizadorBtn.vue";
// import Pdf from "@/components/presupuestado/generadorPDFPresupuesto.vue"

export default {
  components: {
    cartElement,
    AddressCreator,
    CotizadorBtn
    // Pdf
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      loading: 0,
      observaciones: "",
      observacionesAgencia: "",
      referencia: "",
      direcciones: false,
      selectedDireccion: null,
      customAddress: {
        addressName: "",
        street: "",
        cp: "",
        city: "",
        country: "Spain",
        state: "",
        stateCode: "",
        statecode: "",
        district: "",
        email: "",
        phoneNumber: "",
        addresstype: "S"
      },
      avalibleCustomAddress: false,
      misPrecios: {},
      isSelecting: false,
      idImg: 0,
      confirmDialog: false,
      selectedReprocesosId: [],
      operationType: "pedido",

      // TODO: DEBUG Eliminar cuando terminemos las pruebas
      jsonAca: {},
      acaLoading: false,
      acaError: false
    };
  },
  computed: {
    ...mapGetters("config", [
      "loggedClient",
      "userOfClient",
      "comercialToken",
      "translateTecnica",
      "activeComercial",
      "clientCartAvalible",
      "defaultPdfConfig",
      "localUserOfClient"
    ]),
    ...mapGetters("carrito", [
      "actualCart",
      "countClientCart",
      "totalActualCart",
      "shippingAddress",
      "loadingCarrito",
      "countComercialCart",
      "countClientCart"
    ]),
    ...mapGetters("modelo", [
      "currencySymbol",
      "modelCode",
      "modelInfoFromCatalog"
    ]),
    avalibleConfirm() {
      let customAddress =
        (!this.direcciones && this.selectedDireccion) ||
        (this.direcciones && this.avalibleCustomAddress);

      return (
        this.actualCart.length > 0 &&
        customAddress &&
        this.loading == 0 &&
        this.observacionesValid &&
        this.observacionesAgenciaValid &&
        this.referenceValid
      );
    },
    observacionesValid() {
      return this.observaciones.length <= 250;
    },
    observacionesAgenciaValid() {
      return this.observacionesAgencia.length <= 250; 
    },
    referenceValid() {
      return this.referencia.length <= 100;
    },
    logo() {
      return this.customImg != null
        ? this.customImg
        : this.modelInfoFromCatalog &&
            (this.modelInfoFromCatalog.originalBrand == "STM" ||
              this.modelInfoFromCatalog.originalBrand == "STA")
          ? "https://static.gorfactory.es/b2b/Calculadora/logo_stamina.png"
          : "https://static.gorfactory.es/b2b/Calculadora/logo_roly.png";
    },

    totalSelectedReprocesos() {
      return this.actualCart.reduce((total, reproceso) => {
        if (this.selectedReprocesosId.includes(reproceso.id)) {
          return total + reproceso.total;
        }
        return total;
      }, 0);
    },

    totalAcaEnvio() {
      if (
        this.avalibleAca
      ) {
        let totalEnvio = 0;

        this.jsonAca.ReprocesosOrders.forEach(order => {
          order.Suborders.forEach(sub => {
            totalEnvio += sub.PorteCliente || 0;
          });
        });

        return totalEnvio;
      }

      return 0;
    },

    totalImpuestos() {
      if (
        this.avalibleAca
      ) {
        let totalImpuestos = 0;

        this.jsonAca.ReprocesosOrders.forEach(order => {
          order.Suborders.forEach(sub => {
            if (sub.Impuestos && sub.Impuestos.length > 0) {
              sub.Impuestos.forEach(tax => {
                totalImpuestos += tax.Iva || 0;
              });
            }
          });
        });

        return totalImpuestos;
      }

      return 0;
    },

    totalOtrosCalculos() {
      if (
        this.avalibleAca
      ) {
        let totalOtros = 0;

        this.jsonAca.ReprocesosOrders.forEach(order => {
          order.Suborders.forEach(sub => {
            totalOtros += (sub.GastosMani || 0) + (sub.Canon || 0) + (sub.Despaduana || 0) + (sub.ArancelUk || 0);
          });
        });

        return totalOtros;
      }

      return 0;
    },

    granTotal() {
      // Sumamos todo para el importe final
      return (this.totalSelectedReprocesos || 0) + 
            (this.totalAcaEnvio || 0) + 
            (this.totalImpuestos || 0) + 
            (this.totalOtrosCalculos || 0);
    },

    avalibleAca() {
      return this.jsonAca &&
        this.jsonAca.ReprocesosOrders &&
        this.jsonAca.ReprocesosOrders.length > 0 &&
        !this.acaError
    }
  },
  watch: {
    dialog(newVal) {
      console.log("🚀 ~ dialog ~ newVal:", newVal);
      if (newVal != this.localDialog) this.localDialog = newVal;

      if (newVal) {
        this.fetchAddress();
      }
    },
    localDialog(newVal) {
      if (newVal != this.dialog) {
        this.$emit("cerrar");
      }

      if (newVal) {
        this.fetchActualCart();

        if (!this.shippingAddress?.length) this.fetchAddress();
      }

      if (newVal) {
        this.$nextTick(() => {
          this.$refs.cartDialog.showScroll();
        });
      }
    },
    comercialToken(newVal) {
      if (newVal && this.localDialog) {
        this.fetchActualCart();
      }
    },
    shippingAddress(newVal) {
      if (newVal.length > 0) {
        // Buscamos la dirección actual
        const search = newVal.find(d => d.codToken == this.selectedDireccion);

        if (!search) {
          this.selectedDireccion =
            newVal.find(a => a.isDefault)?.codToken ?? newVal[0].codToken;
        }
      }
    }
  },
  created() {
    this.misPrecios = this.defaultPdfConfig;
  },
  methods: {
    ...mapActions("carrito", [
      "fetchActualCart",
      "deleteActualCart",
      "confirmActualCart",
      "fetchAddress",
      "dowloadAllPresupuestosInCart",
      "dowloadAllBocetosInCart",
      "callAcaExtranet"
    ]),
    getReprocesoFromCart(idReproceso) {
      return this.actualCart.find(r => r.id == idReproceso);
    },
    getReprocesoTotalFromCart(idReproceso) {
      let actualRep = this.getReprocesoFromCart(idReproceso)

      if (!actualRep) {
        console.error(`No hemos encontrado el precio total para el reproceso ${idReproceso} en el carrito`)
        return 0;
      }

      return actualRep?.total ?? 0;
    },
    calculateSubTotal(sub) {
      let total = 
        (sub.PorteCliente || 0) +
        (sub.GastosMani || 0) +
        (sub.Canon || 0) +
        (sub.Despaduana || 0) +
        (sub.ArancelUk || 0);
      
      // Sumar impuestos del array
      if (sub.Impuestos && sub.Impuestos.length > 0) {
        sub.Impuestos.forEach(tax => {
          total += (tax.Iva || 0);
        });
      }


      // Sumamos lo que cuesta en el carrito
      const actualRep = this.getReprocesoTotalFromCart(sub.IdReproceso)
      

      return total + actualRep;
    },
    getOrderBaseAmount(order) {
        if (!order || !order.Suborders) return 0;
        return order.Suborders.reduce((acc, sub) => {
            return acc + this.getReprocesoTotalFromCart(sub.IdReproceso);
        }, 0);
    },
    getOrderShipping(order) {
        if (!order || !order.Suborders) return 0;
        return order.Suborders.reduce((acc, sub) => acc + (sub.PorteCliente || 0), 0);
    },
    getOrderExtras(order) {
        if (!order || !order.Suborders) return {};
        const extras = {
            GastosMani: 0,
            Canon: 0,
            Despaduana: 0,
            ArancelUk: 0,
            Bultos: 0
        };
        order.Suborders.forEach(sub => {
            extras.GastosMani += sub.GastosMani || 0;
            extras.Canon += sub.Canon || 0;
            extras.Despaduana += sub.Despaduana || 0;
            extras.ArancelUk += sub.ArancelUk || 0;
            extras.Bultos += sub.Bultos || 0;
        });
        return extras;
    },
    getOrderTaxes(order) {
        if (!order || !order.Suborders) return [];
        const taxes = {};
        order.Suborders.forEach(sub => {
            if (sub.Impuestos) {
                sub.Impuestos.forEach(tax => {
                    const key = tax.DescrIva || 'IVA';
                    if (!taxes[key]) {
                        taxes[key] = { DescrIva: key, Iva: 0 };
                    }
                    taxes[key].Iva += tax.Iva || 0;
                });
            }
        });
        return Object.values(taxes);
    },
    calculateOrderTotal(order) {
        const base = this.getOrderBaseAmount(order);
        const shipping = this.getOrderShipping(order);
        const taxes = this.getOrderTaxes(order).reduce((acc, t) => acc + t.Iva, 0);
        const extrasObj = this.getOrderExtras(order);
        const extras = extrasObj.GastosMani + extrasObj.Canon + extrasObj.Despaduana + extrasObj.ArancelUk;
        
        return base + shipping + taxes + extras;
    },
    updateSelectedId(selectedIds) {
      this.$set(this, 'selectedReprocesosId', selectedIds);
    },
    dowloadAllPresupuestosInCartWithPrices() {
      if (this.loading != 0 || this.loadingCarrito || this.totalActualCart == 0)
        return;

      this.dowloadAllPresupuestosInCart({
        ...this.misPrecios,
        reprocesosToPrint: this.selectedReprocesosId
      });
    },
    dowloadAllBocetosInCartModificaciones() {
      if (this.loading != 0 || this.loadingCarrito || this.totalActualCart == 0)
        return;

      this.dowloadAllBocetosInCart({
        ...this.misPrecios,
        reprocesosToPrint: this.selectedReprocesosId
      });
    },
    resetImg() {
      this.misPrecios.CustomLogo = null;
      this.misPrecios.CustomLogoPath = null;
      this.idImg = 0;
    },
    handleFileImport() {
      this.isSelecting = true;

      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },
    selectFile(event) {
      const file = event.target.files[0];

      if (file) {
        var reader = new FileReader();
        var image = new Image();
        reader.onload = function () {
          image.onload = function () {
            // you can check the image width and height here
            var width = this.width;
            var height = this.height;

            if (width > 500 && height > 500) {
              throw "La imagen debe ser menor de 500x500";
            }
          };

          image.src = this.result;
        };

        reader.addEventListener(
          "loadend",
          () => {
            const base64 = reader.result;
            // this.$set(this.misPrecios, "CustomLogo", file);
            this.misPrecios.CustomLogo = base64;
            // this.$set(this.misPrecios, "CustomLogoPath", base64);
            this.misPrecios.CustomLogoPath = base64;
            this.idImg++;
          },
          { once: true }
        );

        reader.readAsDataURL(file);
      }
    },
    async openConfirmDialog() {
      this.confirmDialog = true;
      this.acaLoading = true;
      this.jsonAca = null;
      this.acaError = false;
      try {
        this.jsonAca = await this.callAcaExtranet({
          observaciones: this.observaciones,
          referencia: this.referencia,
          direcciones: this.direcciones,
          addressCode: this.selectedDireccion,
          addressCustom: !this.direcciones ? null : this.customAddress,
          reprocesosIds: this.selectedReprocesosId
        })
      }
      catch {
        this.acaError = true;
      }
      this.acaLoading = false;
    },
    cerrar: function () {
      this.confirmDialog = false;
      this.localDialog = 0;
      this.$emit("cerrar");
    },
    async deleteCart() {
      if (this.loading != 0 || this.loadingCarrito || this.totalActualCart == 0)
        return;

      this.loading++;
      await this.deleteActualCart();
      this.loading--;
      this.cerrar();
    },
    async confirmAll() {

      if (!this.avalibleConfirm || this.loading != 0 || this.selectedReprocesosId.length == 0) {
        console.warn("No se puede confirmar con las condiciones actuales")
        return;
      }

      try {
        this.loading++;
        await this.confirmActualCart({
          observaciones: this.observaciones,
          observacionesAgencia: this.observacionesAgencia,
          referencia: this.referencia,
          direcciones: this.direcciones,
          addressCode: this.selectedDireccion,
          addressCustom: !this.direcciones ? null : this.customAddress,
          reprocesosIds: this.selectedReprocesosId,
          isPresupuesto: this.operationType != "pedido"
        });
        this.observaciones = "";
        this.observacionesAgencia = "";
        this.referencia = "";
        this.cerrar();
        parent.postMessage({ type: "reloadCart" }, "*");
      } finally {
        this.loading--;
      }
    }
  }
};
</script>

<style lang="scss">
.max-width-fit-content {
  max-width: fit-content;
}
.v-application--is-ltr
  .v-textarea.v-text-field--enclosed
  .v-text-field__slot
  textarea {
  font: normal normal normal 0.75rem/0.9375rem $heading-font-family;
  letter-spacing: 0px;
}

.cart-modal {
  max-height: 95vh !important;

  .subtitle-button {
    font-size: 10px;
    color: var(--Color-Grey-600, #787878);
  }

  .total-span {
    color: var(--Color-Grey-600, #787878);
    font-family: $heading-font-family;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .price-total-span {
    color: var(--Color-Black, #121212);
    font-family: $heading-font-family;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .v-text-field > .v-input__control > .v-input__slot:before {
    border-style: hidden !important;
  }

  .v-divider.theme--light {
    border-color: #707070;
  }

  .radio-group-direction .v-radio > .v-label {
    font: normal normal normal 0.75rem/0.9375rem $heading-font-family;
    letter-spacing: 0px;
  }

  .label-input {
    font: normal normal 600 0.75rem/0.9375rem $heading-font-family;
    letter-spacing: 0px;
  }

  // .title-presupuestos-realizados {
  //   font: normal normal normal 31px/39px $heading-font-family;
  //   letter-spacing: 0px;
  //   color: black;
  // }

  .clean-cart-text {
    padding-top: 0;
    padding-bottom: 0;

    a {
      color: var(--Color-Grey-600, #787878);
      text-align: right;
      font-family: $heading-font-family;
      font-size: 0.625rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
      letter-spacing: 0px;
      // color: var(--v-primary-darken3);
      cursor: pointer;
      text-transform: uppercase;
      transition: all 0.3s;

      &:hover {
        color: var(--v-primary-darken2);
      }

      &[disabled] {
        cursor: not-allowed;
        color: #707070;
      }
    }
  }

  .title1 {
    font: normal normal 600 1rem/20px $heading-font-family;
    letter-spacing: 0px;
  }

  .subtitle1 {
    // color: #707070;
    opacity: 1;
    font: normal normal 400 0.9375rem/19px $heading-font-family;
    letter-spacing: 0px;
  }

  .presupuestoBody {
    font: normal normal 300 0.9375rem/19px $body-font-family;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;

    .encabezado {
      font-size: 0.75rem;
      display: flex;
      justify-content: center;
      flex-direction: column;

      .v-btn {
        max-width: 320px;
        .v-btn__content {
          font-family: $heading-font-family, sans-serif;
          font-size: 17px;
          line-height: 40px;
          font-weight: 500;
          text-transform: none !important;
          letter-spacing: 0 !important;
        }
      }
    }

    .inLineInput {
      // display: flex;
      // align-items: center;
      max-height: 40px;
      letter-spacing: 0px;
      font: normal normal normal 0.75rem/0.9375rem $heading-font-family;

      .v-input {
        margin: 0;
      }
    }
  }
}

.individual-address-item {
  max-width: 400px;
  font: normal normal normal 0.75rem/0.9375rem $heading-font-family;
  letter-spacing: 0px;
}

.cart-item-list {
  .scroll-container {
    max-height: 180px;
  }
}

.title-list {
  font-size: 0.95rem;
}

// .active-panel {
//   box-shadow:
//     0px 3px 1px -2px var(--v-primary-darken2),
//     0px 2px 2px 0px var(--v-primary-darken2),
//     0px 1px 5px 0px var(--v-primary-darken2);
// }

.totalHeader {
  text-shadow: 0 0 1px var(--v-primaryColorText-lighten2);
  color: var(--v-primaryColorText-lighten2);
}

.scroll-container {
  overflow: auto;
}

.loading-cart {
  background-color: #f8f8f8;
  height: 100%;
  padding: 0.9375rem;
}

.dark-btn {
  .btn-icon-presupuesto {
    filter: invert(1);
  }
}
.confirm-dialog-text {
  font-size: 1.1rem;
}

.right-border {
  border-right: 1px solid #707070;
}

.aca-calculation {
  .orders-scroll-container {
  max-height: 300px;
  overflow-y: auto;
  
  /* Personalización scrollbar (opcional, para navegadores webkit) */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
}

/* Tarjeta individual del pedido (Color Hueso/Blanco Roto) */
.order-summary-card {
  background-color: #fafafa !important; /* Color hueso muy suave */
  border: 1px solid #e0e0e0;
  color: #333333 !important; /* Forzamos texto oscuro */
  border-radius: 8px !important;

  /* Cabecera de la tarjeta */
  .order-card-header {
    display: flex;
    align-items: center;
    padding: 8px 16px 4px 16px;

    .order-icon {
      margin-right: 8px;
      color: #616161; /* Grey darken-2 */
    }

    .order-title {
      font-weight: 700;
      color: #424242; /* Grey darken-3 */
      font-size: 0.95rem;
    }
  }

  /* Cuerpo de la tarjeta */
  .order-card-body {
    padding: 8px 16px;
    font-size: 0.875rem; /* text-body-2 estándar */
  }
}

.suborder-item {

  .suborder-info {
    line-height: 1.2;
    display: flex;
    flex-direction: column;
  }

  .suborder-name {
    display: block;
    font-weight: 700;
    font-size: 0.75rem;
    text-align: left;
  }

  .suborder-ref {
    font-size: 0.65rem;
    color: #757575;
  }
}

/* Filas de costes individuales */
.cost-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;

  .cost-label {
    color: #616161; /* Gris oscuro suave para leer bien */
  }

  .cost-value {
    font-weight: 500;
    color: #000;
  }
}

/* Separador interno suave */
.divider-light {
  border-color: rgba(0, 0, 0, 0.08) !important;
}

/* Fila del Total */
.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;

  .total-label {
    font-weight: 700;
    text-transform: uppercase;
    color: var(--v-bannerBackground-base); /* Usa el color primario de tu tema Vuetify */
  }

  .total-value {
    font-size: 1.15rem; /* text-h6 aproximado */
    font-weight: 700;
    color: var(--v-bannerBackground-base);
  }
}
}
</style>
